type CookieOptions = {
    domain: string
    maxAge: number
}

const setCookie = (name: string, value: string | undefined, options: CookieOptions) => {
    if (typeof document === "undefined") return

    const { domain, maxAge } = options

    if (value) {
        document.cookie = `${name}=${value}; max-age=${maxAge}; domain=${domain}; path=/; secure; SameSite=Strict`
        return
    }
    deleteCookie(name, { domain: domain })
}

const getCookie = (name: string) => {
    if (typeof document === "undefined") return undefined

    return document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || undefined
}

const deleteCookie = (name: string, options: Omit<CookieOptions, "maxAge">) => {
    if (typeof document === "undefined") return

    document.cookie = `${name}=; max-age=0; domain=${options.domain}; path=/; secure; SameSite=Strict`
}

export { setCookie, getCookie, deleteCookie }
